export default {"src":"/_next/static/media/logo.1982898a.svg","height":52,"width":249,"blurWidth":0,"blurHeight":0};